var exports = {
  "MO": "VoiceParticipantItem.module__participantRow___MmpfT0",
  "Kq": "VoiceParticipantItem.module__participantRowSpeaking___MmpfT0",
  "JN": "VoiceParticipantItem.module__participantRowDragging___MmpfT0",
  "z": "VoiceParticipantItem.module__participantRowCurrentConnection___MmpfT0",
  "B$": "VoiceParticipantItem.module__participantRowPopoutOpen___MmpfT0",
  "K0": "VoiceParticipantItem.module__participantRowContextMenuActive___MmpfT0",
  "Kt": "VoiceParticipantItem.module__deviceIcon___MmpfT0",
  "iY": "VoiceParticipantItem.module__deviceIconSpeaking___MmpfT0",
  "ns": "VoiceParticipantItem.module__deviceIconCurrent___MmpfT0",
  "zc": "VoiceParticipantItem.module__iconContainer___MmpfT0",
  "F8": "VoiceParticipantItem.module__participantName___MmpfT0",
  "xr": "VoiceParticipantItem.module__participantNameSpeaking___MmpfT0",
  "S$": "VoiceParticipantItem.module__participantNameCurrent___MmpfT0",
  "_q": "VoiceParticipantItem.module__iconsContainer___MmpfT0",
  "nt": "VoiceParticipantItem.module__flexShrinkZero___MmpfT0",
};

module.exports = exports;
